import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import packageFile from '../../../../package.json';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private _httpClient = inject(HttpClient);

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * The i18n JSON files are not content-hashed like the JS bundles, so browsers
     * may keep a stale copy after a release (heuristic caching). Appending the app
     * version to the URL forces a fresh download once per release.
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation> {
        return this._httpClient.get<Translation>(
            `./i18n/${lang}.json?v=${packageFile.version}`
        );
    }
}
